import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { CereusReportType } from '../../enum/reports-filter-type';

@Injectable({
  providedIn: 'root'
})
export class ReportFilterService {
  public showFilterPopup: boolean = false;
  public selectedReport: CereusReportType;
  public selectedCarrier: any[] = [];
  public selectedFacility: any[] = [];
  public selectedLOC: any[] = [];
  public selectedPracticeAddress: any[] = [];
  public selectedStartDateFilter1: Date;
  public selectedStartDateFilter2: Date;
  public selectedEndDateFilter1: Date;
  public selectedEndDateFilter2: Date;
  public selectedYear: number = 2026;
  public selectedStatus: any = null;
  public selectedState: any = null;
  public selectedPrefix: any = null;
  public selectedDateFilter1 = "This Month";
}
